<template>
	<div class="cps-store-classify-container" ref="storeLayout">
		<ul class="tab-box" style="z-index: 999;">
			<li class="tab-item" 
				v-for="(item,index) in $store.getters.getClassifyList"
				:key="index"
				:class="[item.id === tabActive ? 'active':'']"
				@click="handleChangeTab(item.id)">
				<a href="javascript:;">
					<span class="name">{{item.typeName}}</span>
					<span class="line"></span>
				</a>
			</li>
		</ul>
		<div class="page-loadmore-wrapper">
			<vueWaterfallEasy 
				:imgsArr="listData"
				:allLoaded="allLoaded"
				:loading="loading"
				@scrollReachBottom="loadData"
				ref="waterfall">
			</vueWaterfallEasy>
		</div>

		<StoreBack />
	</div>
</template>

<script>
	import { getShopSourceList } from '@/api/distribution'
	import vueWaterfallEasy from './components/Waterfall'
	import StoreBack from './components/StoreBack'


	export default {
		data() {
			return {
				imgsArr: [],
				listData: [],
				pageNumber: 1,
				total: null,
				loading: false,
				tabActive: null,
				allLoaded: false,
			}
		},
		components: {
			vueWaterfallEasy,
			StoreBack
		},
		methods: {
			loadData() {
				if(this.allLoaded) return;
				this.loading = true;

				let params = {
					shopNum: this.$route.params.shopId,
					typeId: this.tabActive || '',
					pageNumber: this.pageNumber,
					pageSize: 20
				}

				getShopSourceList(params)
				.then(res=>{
					this.loading = false;
					if(res.success) {
						let _data = res.data.dataList,
							_imgArr = [];
						_data.forEach(item=>{
							_imgArr.push({
								src: item.our_image || item.image,
								href: 'javascript:;'
							})
						})
						this.imgsArr = [...this.imgsArr,_imgArr];
						this.listData = [...this.listData,..._data];

						this.total = parseInt(res.data.count);

						if(this.listData.length === this.total){
							this.allLoaded = true;
						}else{
							this.pageNumber ++ ;
						}
					}
				})
			},
			//切换tab
			handleChangeTab(id) {
				if(this.loading) return;
				if(this.tabActive === id) return;

				this.tabActive = id;
				this.pageNumber = 1;
				this.total = null;
				this.listData = [];
				this.allLoaded = false;

				this.loadData()
			},
			//返回切换方向
			getDirection(startx, starty, endx, endy) {
				let angx = endx - startx;
				let angy = endy - starty;
				let result = 0;

				//如果滑动距离太短
				if (Math.abs(angx) < 50 && Math.abs(angy) < 50) {
					return result;
				}
				let angle = Math.atan2(angy, angx) * 180 / Math.PI;

				if (angle >= -135 && angle <= -45) {
					result = 1;
				} else if (angle > 45 && angle < 135) {
					result = 2;
				} else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
					result = 3;
				} else if (angle >= -45 && angle <= 45) {
					result = 4;
				}
				return result;
			},
			//滑动切换tab
			touchChangeTab() {
				if(this.$route.name==='storeClassify'){
					let startX = 0,
						startY = 0;

					this.$refs.storeLayout.addEventListener('touchstart',e=>{
						startX = e.touches[0].pageX;
						startY = e.touches[0].pageY;
					})
					this.$refs.storeLayout.addEventListener('touchend',e=>{
						let endX = e.changedTouches[0].pageX,
							endY = e.changedTouches[0].pageY,
							direction = this.getDirection(startX, startY, endX, endY);

						if(this.loading) return;
						if(!this.$store.getters.getClassifyList.length) return;
						
						let classifyList = this.$store.getters.getClassifyList;
						let activeIndex = classifyList.findIndex(item=>{
							return item.id === this.tabActive
						})
						if(direction === 3) {
							activeIndex ++;
							this.$store.getters.getClassifyList.forEach((item,index)=>{
								if(activeIndex === index){
									this.handleChangeTab(item.id)
								}
							})
							return;
						}
						if(direction === 4) {
							activeIndex --;
							this.$store.getters.getClassifyList.forEach((item,index)=>{
								if(activeIndex === index){
									this.handleChangeTab(item.id);
								}
							})
							return;
						}
					})
				}
			}
		},
		mounted() {
			this.tabActive = this.$route.query.typeId;
			this.loadData();
			this.touchChangeTab()
		}
	}
</script>

<style lang="scss">

	.cps-store-classify-container{
		height: 100vh;
		width: 100vw;

		.tab-box{
			display: flex;
			align-items: center;
			position: fixed;
			width: 100%;
			height: 80px;
			background-color: #fff;
			z-index: 999;
		}
		.tab-item{
			padding: 20px 30px;
			font-size: 28px;
			position: relative;
			transform: translate3d(0, 0, 0);
			transition: all .3s;
			transform: scale(1);
			
			a{
				display: inline-block;
				text-decoration: none;
				color: #666666;
				position: relative;

				.name{
					position: relative;
					z-index: 2;
				}
			}
			.line{
				height: 4px;
				width: 100%;
				position: absolute;
				bottom: 3px;
				left: 0;
				background-color: transparent;
				transition: .3s;
				z-index: 1;
			}
			&.active{
				transform: scale(1.05);

				a{
					color: #222222;
				}
				.line{
					background:rgba(255,189,122,.8);
				}
			}
		}
		.page-loadmore-wrapper{
			position: fixed;
			top: 80px;
			left: 0;
			right: 0;
			bottom: 0;
			padding: 0 5px;
			box-sizing: border-box;
			z-index: 1;

			.vue-waterfall-easy-scroll{
				padding-top: 20px;
			}
		}
		.cps-store-list{
			margin-top: 30px;
			z-index: 0;
		}
		.data-none{
			display: flex;
			align-items: center;
			justify-content: center;
			height: 50px;
			color: #ccc;
			font-size: 28px;
		}
		.mint-loadmore-bottom{
			display: flex;
			align-items: center;
			justify-content: center;
			height: 50px;
			color: #ccc;
			font-size: 28px;

			.spinner{
				margin-right: 20px;
			}
			.jt{
				transition: .3s;
				margin-right: 5px;
			}
			.is-rotate{
				transform: rotate(180deg);
			}
		}
	}
</style>